/**
 * Контент 7 публичных текстовых страниц (TZ §12)
 * Тексты подготовлены автором, юридическая экспертиза вне MVP - клиент
 * по необходимости заменит соглашение/политику на согласованные с юристом
 */
import type { StaticPageProps } from "./StaticPage";

export const FAQ_CONTENT: StaticPageProps = {
  title: "FAQ",
  subtitle: "Ответы на частые вопросы о SpectrAI",
  blocks: [
    {
      qa: [
        { q: "Что такое SpectrAI?",
          a: "Это платформа-агрегатор: десятки топ-моделей ИИ под одним счётом. Текст, код, картинки, видео и аудио без подписок на каждый сервис" },
        { q: "Как устроена оплата?",
          a: "У вас один баланс в кредитах. Каждый запрос списывает кредиты по тарифу модели. Цена видна перед запуском" },
        { q: "Что будет при ошибке провайдера?",
          a: "Кредиты вернутся автоматически. Все операции видны в истории на странице «Платежи и кредиты»" },
        { q: "Можно ли получить бесплатные кредиты?",
          a: "Да: стартовый бонус при регистрации, промокоды от партнёров и реферальная программа" },
        { q: "Где хранятся мои файлы?",
          a: "В защищённом облачном хранилище. По умолчанию срок хранения - 30 дней. Любой файл можно удалить раньше" },
        { q: "Сохраняются ли мои переписки?",
          a: "Да, история чатов доступна на странице «История чатов». Любой диалог можно удалить или заархивировать" },
        { q: "Какие модели поддерживаются?",
          a: "Текстовые (GPT, Claude, Gemini, Llama, DeepSeek), image-генерация (DALL·E, Flux, Midjourney), редактирование, видео (Runway, Kling), аудио (TTS, Whisper), апскейл" },
      ],
    },
  ],
};

export const HELP_CONTENT: StaticPageProps = {
  title: "Помощь",
  subtitle: "Быстрая шпаргалка по работе с SpectrAI",
  blocks: [
    { heading: "С чего начать",
      paragraphs: [
        "После регистрации вы попадаете в чат. Выберите модель в горизонтальной полосе, введите запрос и нажмите «Отправить». Ответ начинает приходить сразу"
      ] },
    { heading: "Как сгенерировать изображение или аудио",
      paragraphs: [
        "В разделе «Модели» выберите категорию (Изображения, Видео, Аудио, Апскейл) и нужную модель. Откроется форма с параметрами - заполните и нажмите «Сгенерировать»"
      ] },
    { heading: "Куда смотреть, если что-то не так",
      list: [
        "Баланс и история операций - на странице «Платежи и кредиты»",
        "Скачанные/созданные файлы - в разделе «Файлы»",
        "Статистика по моделям - в «Мониторинге»",
        "Если генерация упала, кредиты вернутся автоматически",
      ] },
    { heading: "Не нашли ответ?",
      paragraphs: ["Напишите нам через форму поддержки в личном кабинете - отвечаем в течение суток"] },
  ],
};

export const CONTACTS_CONTENT: StaticPageProps = {
  title: "Контакты",
  subtitle: "Как с нами связаться",
  blocks: [
    { paragraphs: [
        "По любым вопросам поддержки: support@crystal.ai",
        "Для партнёрств и интеграций: partners@crystal.ai",
        "Юридический отдел: legal@crystal.ai",
      ] },
    { heading: "Время ответа",
      paragraphs: ["Будние дни - в течение нескольких часов. Выходные и праздники - до 24 часов"] },
  ],
};

export const TERMS_CONTENT: StaticPageProps = {
  title: "TERMS OF SERVICE (ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ)",
  subtitle: "Дата вступления в силу: 30.06.2026",
  blocks: [
    { heading: "1. Общие положения",
      paragraphs: [
        "1.1. Настоящее Пользовательское соглашение (далее — «Соглашение») регулирует отношения между ТОО «AYBAT COMPANY» (БИН: 190640016708), в лице руководителя Берсугурова Анвара Айдаровича (далее — «Сервис», «Компания», «мы»), и пользователем сайта SpectrAI (далее — «Пользователь»).",
        "1.2. Юридический адрес Компании: 050008, Республика Казахстан, г. Алматы, Бостандыкский район, пр. Абая, д. 68/74, офис 103.",
        "1.3. Контактный адрес электронной почты: SpectrAI@gmail.com",
        "1.4. Используя сайт, создавая учетную запись либо пользуясь функционалом SpectrAI, Пользователь подтверждает, что ознакомился с настоящим Соглашением и полностью принимает его условия.",
      ] },
    { heading: "2. Описание сервиса",
      paragraphs: [
        "2.1. SpectrAI представляет собой платформу, предоставляющую доступ к различным технологиям искусственного интеллекта через единый пользовательский интерфейс.",
        "2.2. Сервис может предоставлять доступ к моделям и технологиям третьих лиц, включая, помимо прочего, языковые модели, генераторы изображений, аудио, видео и иные инструменты искусственного интеллекта.",
        "2.3. Компания не является разработчиком большинства используемых моделей искусственного интеллекта и не гарантирует их доступность, бесперебойную работу либо сохранение одинакового качества ответов.",
        "2.4. Компания вправе в любое время изменять список доступных моделей, функционал платформы, лимиты использования и иные характеристики сервиса без предварительного уведомления.",
      ] },
    { heading: "3. Регистрация и учетная запись",
      paragraphs: [
        "3.1. Для использования отдельных функций Сервиса Пользователь может быть обязан создать учетную запись.",
        "3.2. Пользователь обязан предоставлять достоверную информацию и поддерживать ее актуальность.",
        "3.3. Пользователь несет полную ответственность за безопасность своей учетной записи и всех действий, совершаемых через нее.",
        "3.4. Компания вправе заблокировать или удалить учетную запись в случае нарушения настоящего Соглашения.",
      ] },
    { heading: "4. Правила использования",
      paragraphs: ["Пользователю запрещается:"],
      list: [
        "нарушать законодательство Республики Казахстан либо законодательство страны своего пребывания;",
        "использовать сервис для мошеннической деятельности;",
        "распространять вредоносное программное обеспечение;",
        "предпринимать попытки несанкционированного доступа к инфраструктуре Сервиса;",
        "использовать сервис для спама или автоматизированных злоупотреблений;",
        "использовать сервис для создания незаконного контента;",
        "обходить технические ограничения платформы;",
        "перепродавать доступ к сервису без письменного разрешения Компании.",
      ] },
    { heading: "5. Пользовательский контент",
      paragraphs: [
        "5.1. Пользователь может загружать текст, изображения, документы, аудио, видео и иной контент для обработки моделями искусственного интеллекта.",
        "5.2. Пользователь гарантирует наличие всех необходимых прав на загружаемый контент.",
        "5.3. Пользователь самостоятельно несет ответственность за любой загружаемый контент.",
        "5.4. Компания не осуществляет предварительную модерацию пользовательского контента.",
        "5.5. Пользователь понимает и соглашается, что загружаемые данные могут передаваться поставщикам AI-моделей исключительно в целях обработки запросов.",
      ] },
    { heading: "6. Искусственный интеллект и ограничения ответственности",
      paragraphs: [
        "6.1. Ответы, рекомендации, изображения, аудио, видео, программный код и иные результаты работы искусственного интеллекта формируются автоматически.",
        "6.2. Компания не гарантирует точность, полноту, актуальность или пригодность результатов для конкретных целей Пользователя.",
        "6.3. Результаты работы искусственного интеллекта могут содержать ошибки, неточности, вымышленные сведения либо иные недостатки.",
        "6.4. Пользователь обязан самостоятельно проверять любую информацию, полученную через сервис.",
        "6.5. Компания не несет ответственности за решения, действия, убытки, упущенную выгоду, ущерб репутации либо иные последствия, возникшие вследствие использования результатов работы искусственного интеллекта.",
        "6.6. Сервис не предоставляет юридических, медицинских, финансовых, инвестиционных или иных профессиональных консультаций.",
      ] },
    { heading: "7. Платежи и возвраты",
      paragraphs: [
        "7.1. Использование отдельных функций Сервиса может быть платным.",
        "7.2. Оплата производится способами, доступными на сайте.",
        "7.3. После успешного зачисления средств возврат денежных средств не осуществляется.",
        "7.4. Пользователь соглашается с тем, что цифровые услуги начинают предоставляться немедленно после оплаты.",
        "7.5. Неиспользованный баланс, кредиты, токены либо иные цифровые единицы не подлежат обмену на денежные средства.",
        "7.6. Исключения могут применяться только в случаях, прямо предусмотренных законодательством Республики Казахстан.",
      ] },
    { heading: "8. Доступность сервиса",
      paragraphs: [
        "8.1. Сервис предоставляется по принципу «как есть» (AS IS) и «по мере доступности» (AS AVAILABLE).",
        "8.2. Компания не гарантирует бесперебойную работу платформы.",
        "8.3. Компания вправе временно ограничивать доступ к сервису для проведения технических работ, обновлений или устранения неисправностей.",
      ] },
    { heading: "9. Интеллектуальная собственность",
      paragraphs: [
        "9.1. Все права на программное обеспечение, дизайн, интерфейс, логотипы, тексты и иные элементы SpectrAI принадлежат Компании либо используются на законных основаниях.",
        "9.2. Пользователю предоставляется ограниченное неисключительное право использования Сервиса исключительно в соответствии с настоящим Соглашением.",
        "9.3. Копирование, декомпиляция, распространение или модификация элементов Сервиса без письменного разрешения Компании запрещены.",
      ] },
    { heading: "10. Ограничение ответственности",
      paragraphs: [
        "10.1. Максимальная ответственность Компании по любым претензиям Пользователя ограничивается суммой платежей, фактически уплаченных Пользователем за последние 30 календарных дней.",
        "10.2. Компания не несет ответственности за:",
      ],
      list: [
        "действия поставщиков AI-моделей;",
        "недоступность сторонних сервисов;",
        "потерю данных;",
        "косвенные убытки;",
        "упущенную выгоду;",
        "потерю клиентов, контрактов или деловой репутации.",
      ] },
    { heading: "11. Изменение соглашения",
      paragraphs: [
        "11.1. Компания вправе в любое время изменять настоящее Соглашение.",
        "11.2. Новая редакция вступает в силу с момента публикации на сайте, если иное не указано дополнительно.",
        "11.3. Продолжение использования Сервиса после публикации изменений означает согласие Пользователя с новой редакцией Соглашения.",
      ] },
    { heading: "12. Прекращение доступа",
      paragraphs: [
        "12.1. Компания вправе ограничить или прекратить доступ Пользователя к сервису при нарушении настоящего Соглашения.",
        "12.2. Пользователь вправе прекратить использование Сервиса в любое время.",
      ] },
    { heading: "13. Применимое право",
      paragraphs: [
        "13.1. Настоящее Соглашение регулируется законодательством Республики Казахстан.",
        "13.2. Все споры подлежат рассмотрению в соответствии с законодательством Республики Казахстан по месту регистрации Компании, если иное не предусмотрено обязательными нормами права.",
      ] },
    { heading: "14. Контактная информация",
      paragraphs: [
        "ТОО «AYBAT COMPANY»",
        "БИН: 190640016708",
        "Адрес: 050008, Республика Казахстан, г. Алматы, Бостандыкский район, пр. Абая, д. 68/74, офис 103",
        "E-mail: SpectrAI@gmail.com",
      ] },
  ],
};

export const PRIVACY_CONTENT: StaticPageProps = {
  title: "PRIVACY POLICY (ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ)",
  subtitle: "Дата вступления в силу: 30.06.2026",
  blocks: [
    { heading: "1. Общие положения",
      paragraphs: [
        "Настоящая Политика конфиденциальности определяет порядок сбора, использования, хранения и защиты информации пользователей сервиса SpectrAI.",
        "Оператором персональных данных является:",
        "ТОО «AYBAT COMPANY»",
        "БИН: 190640016708",
        "Адрес: 050008, Республика Казахстан, г. Алматы, Бостандыкский район, пр. Абая, д. 68/74, офис 103",
        "E-mail: SpectrAI@gmail.com",
        "Используя SpectrAI, Пользователь соглашается с условиями настоящей Политики конфиденциальности.",
      ] },
    { heading: "2. Какие данные мы собираем",
      paragraphs: ["Мы можем собирать следующие категории данных:"] },
    { heading: "2.1. Данные учетной записи",
      list: [
        "адрес электронной почты;",
        "имя пользователя;",
        "идентификаторы учетной записи;",
        "иные данные, предоставленные Пользователем при регистрации.",
      ] },
    { heading: "2.2. Технические данные",
      list: [
        "IP-адрес;",
        "тип устройства;",
        "версия браузера;",
        "операционная система;",
        "дата и время доступа;",
        "журналы ошибок и технических событий.",
      ] },
    { heading: "2.3. Платежная информация",
      paragraphs: [
        "При оплате услуг данные банковских карт обрабатываются платежными системами и платежными провайдерами.",
        "SpectrAI не хранит полные реквизиты банковских карт пользователей.",
      ] },
    { heading: "2.4. Данные использования",
      paragraphs: ["Мы можем собирать информацию о взаимодействии Пользователя с сервисом:"],
      list: [
        "используемые функции;",
        "история платежей;",
        "информация о тарифах;",
        "статистика использования.",
      ] },
    { heading: "3. Загружаемый пользователем контент",
      paragraphs: ["Пользователь может загружать:"],
      list: [
        "текст;",
        "изображения;",
        "документы;",
        "аудио;",
        "видео.",
      ] },
    { paragraphs: [
        "Указанный контент может временно обрабатываться для выполнения запроса пользователя.",
        "SpectrAI не осуществляет долгосрочное хранение загруженных файлов после завершения обработки, если иное прямо не указано в функционале сервиса.",
      ] },
    { heading: "4. Использование данных",
      paragraphs: ["Мы используем данные для:"],
      list: [
        "предоставления доступа к сервису;",
        "выполнения запросов пользователей;",
        "обработки платежей;",
        "поддержки пользователей;",
        "обеспечения безопасности платформы;",
        "предотвращения мошенничества;",
        "улучшения работы сервиса;",
        "соблюдения требований законодательства.",
      ] },
    { heading: "5. Передача данных третьим лицам",
      paragraphs: ["Для предоставления услуг мы можем передавать информацию следующим категориям получателей:"] },
    { heading: "Поставщики AI-технологий",
      paragraphs: ["Запросы пользователя могут передаваться сторонним поставщикам моделей искусственного интеллекта, включая, помимо прочего:"],
      list: [
        "OpenAI;",
        "Anthropic;",
        "Google;",
        "иным поставщикам AI-сервисов.",
      ] },
    { paragraphs: ["Передача осуществляется исключительно в объеме, необходимом для обработки запроса пользователя."] },
    { heading: "Платежные провайдеры",
      paragraphs: ["Информация, необходимая для обработки платежей, может передаваться платежным системам и банкам-партнерам."] },
    { heading: "Государственные органы",
      paragraphs: ["В случаях, предусмотренных законодательством Республики Казахстан, мы можем раскрывать информацию государственным органам по их законному запросу."] },
    { heading: "6. Международная передача данных",
      paragraphs: [
        "Поскольку SpectrAI использует международные технологические сервисы и поставщиков искусственного интеллекта, данные пользователей могут обрабатываться за пределами Республики Казахстан.",
        "Используя сервис, Пользователь соглашается с такой передачей данных.",
      ] },
    { heading: "7. Защита информации",
      paragraphs: ["Мы принимаем разумные организационные и технические меры для защиты данных пользователей от:"],
      list: [
        "несанкционированного доступа;",
        "изменения;",
        "раскрытия;",
        "уничтожения.",
      ] },
    { paragraphs: ["Однако ни один способ передачи данных через Интернет не может гарантировать абсолютную безопасность."] },
    { heading: "8. Cookies",
      paragraphs: ["SpectrAI может использовать cookies и аналогичные технологии для:"],
      list: [
        "авторизации пользователей;",
        "сохранения настроек;",
        "анализа работы сервиса;",
        "улучшения пользовательского опыта.",
      ] },
    { paragraphs: ["Пользователь может ограничить использование cookies через настройки своего браузера."] },
    { heading: "9. Срок хранения данных",
      paragraphs: ["Мы храним данные только в течение периода, необходимого для:"],
      list: [
        "предоставления услуг;",
        "исполнения договорных обязательств;",
        "соблюдения требований законодательства;",
        "разрешения споров;",
        "предотвращения мошенничества.",
      ] },
    { paragraphs: ["После достижения целей обработки данные могут быть удалены или обезличены."] },
    { heading: "10. Права пользователя",
      paragraphs: ["Пользователь вправе:"],
      list: [
        "запросить информацию о своих данных;",
        "потребовать исправления неточных данных;",
        "запросить удаление данных в случаях, предусмотренных законодательством;",
        "отозвать согласие на обработку персональных данных;",
        "обратиться с вопросами по обработке данных через контактный адрес электронной почты.",
      ] },
    { heading: "11. Дети",
      paragraphs: [
        "Сервис не предназначен для лиц младше возраста, установленного законодательством страны пользователя.",
        "Если нам станет известно о получении данных несовершеннолетнего с нарушением применимого законодательства, такие данные могут быть удалены.",
      ] },
    { heading: "12. Изменения политики",
      paragraphs: [
        "Компания вправе изменять настоящую Политику конфиденциальности в любое время.",
        "Актуальная версия всегда публикуется на сайте SpectrAI.",
        "Продолжение использования сервиса после публикации изменений означает согласие пользователя с новой редакцией Политики.",
      ] },
    { heading: "13. Контактная информация",
      paragraphs: [
        "ТОО «AYBAT COMPANY»",
        "БИН: 190640016708",
        "Адрес: 050008, Республика Казахстан, г. Алматы, Бостандыкский район, пр. Абая, д. 68/74, офис 103",
        "E-mail: SpectrAI@gmail.com",
        "По вопросам обработки персональных данных пользователь может обратиться по указанному адресу электронной почты.",
      ] },
  ],
};

export const REFUNDS_CONTENT: StaticPageProps = {
  title: "Правила возврата кредитов",
  subtitle: "Когда кредиты возвращаются автоматически, а когда - по запросу",
  blocks: [
    { heading: "Автоматический возврат",
      list: [
        "Техническая ошибка провайдера (сервер недоступен, таймаут, 5xx)",
        "Превышение лимита запросов на стороне провайдера (rate limit)",
        "Прерывание стриминга по нашей вине",
        "Внутренние ошибки SpectrAI",
      ] },
    { heading: "Возврат по запросу",
      paragraphs: [
        "Если модель сгенерировала результат, но он явно некачественный (повторы, пустой ответ, не на тот язык) - напишите в поддержку с указанием ID запроса",
        "Решение принимается в течение 1 рабочего дня. Срок рассмотрения для сложных кейсов - до 5 рабочих дней",
      ] },
    { heading: "Когда возврат невозможен",
      list: [
        "Результат корректен по техническим критериям, но не нравится визуально/стилистически",
        "Запрос нарушал правила использования",
        "Использование Сервиса прекращено из-за нарушения соглашения",
      ] },
  ],
};

export const CREDITS_POLICY_CONTENT: StaticPageProps = {
  title: "Описание кредитной системы",
  subtitle: "Как устроены кредиты в SpectrAI",
  blocks: [
    { paragraphs: [
        "Кредит - это внутренняя единица учёта Сервиса. Один кредит не привязан к фиксированной денежной сумме: цена зависит от категории модели и сложности запроса",
        "Кредиты не подлежат возврату за деньги, но могут быть возвращены на ваш баланс автоматически при ошибке (см. «Правила возврата кредитов»)",
      ] },
    { heading: "Как расходуются кредиты",
      list: [
        "Текстовые модели: тарификация по токенам (input + output). Цена видна перед запросом и в истории операций",
        "Изображения и аудио: фиксированная цена за результат (за изображение или за сгенерированный файл)",
        "Видео: фиксированная цена за ролик. При сбое генерации - автоматический возврат",
      ] },
    { heading: "Как получить кредиты",
      list: [
        "Стартовый бонус - автоматически после регистрации",
        "Промокоды - активируйте на странице «Платежи и кредиты»",
        "Реферальная программа - вы и приглашённый друг получаете кредиты после его первого запроса",
        "Пакеты - покупка через платёжный шлюз (когда он будет подключён)",
      ] },
    { heading: "Срок действия",
      paragraphs: ["Кредиты не сгорают. Любые ограничения по сроку действия отдельных промокодов указываются в условиях самого промокода"] },
  ],
};
